import { cn } from "@/lib/utils";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

type NumberCardProps = {
  className?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  value: React.ReactNode;
  valueLabel?: string;
  valueDescription?: React.ReactNode;
  icon?: React.ReactNode;
};

export function NumberCard({
  title,
  description,
  icon,
  value,
  valueLabel,
  valueDescription,
  className,
  ...props
}: NumberCardProps) {
  return (
    <Card
      {...props}
      className={cn("flex h-full flex-col justify-between", className)}
    >
      <CardHeader className="pb-2 md:pb-2">
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      <CardContent>
        <p
          aria-label={valueLabel}
          className="flex items-center gap-2 text-2xl font-bold md:text-3xl [&_svg]:size-6"
        >
          {icon}
          {value}
        </p>
        {valueDescription ? (
          <p className="text-muted-foreground text-sm">{valueDescription}</p>
        ) : null}
      </CardContent>
    </Card>
  );
}
